import Qs from 'qs';
import axios from 'axios';
import { apiBaseUrls } from '@saucelabs/sl-util-config';
import TestObjectClient from '@saucelabs/web-rdc-client';
import { rdcApp, rdcManual } from '@saucelabs/sl-util-axios';

const handleResponse = ({ data }) => {
  if (data.status === 'ERROR') {
    throw data.error;
  }

  return data;
};

export const createAppSession = ({ dataCenterId, deviceId, appId, tunnelIdentifier }) => {
  const endpoint = rdcManual[dataCenterId];
  return endpoint
    .post(`/manual/devices/${deviceId}/openWithProject`, {
      projectId: appId,
      tunnelIdentifier,
    })
    .then(handleResponse);
};

export const createAppSessionExperiment = ({ dataCenterId, deviceId, appId, tunnelIdentifier }) => {
  const endpoint = rdcManual[dataCenterId];
  return endpoint
    .post(`/manual/devices/${deviceId}/openWithApp`, {
      appId,
      tunnelIdentifier,
    })
    .then(handleResponse);
};

export const createBrowserSession = ({ dataCenterId, deviceId, tunnelIdentifier }) => {
  const endpoint = rdcManual[dataCenterId];
  return endpoint
    .post(`/manual/devices/${deviceId}/open`, {
      tunnelIdentifier,
    })
    .then(handleResponse);
};

export const connectDevice = ({ dataCenterId, deviceSessionId, elementId }) => {
  const url = apiBaseUrls.rdcManual[dataCenterId];
  return TestObjectClient.connectDevice(url, deviceSessionId, elementId);
};

export const fetchAppVersion = (appId) => (
  rdcApp.get(`/apps/${appId}`)
);

export const fetchApps = ({ searchTerm, osFilters }) => rdcApp.get('/apps', {
  params: { searchTerm, osFilters },
  paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: 'repeat' }),
});

export const fetchFilteredDevices = (payload) => {
  const endpoint = rdcManual[payload.dataCenterId];
  return endpoint.get('/descriptors/filtered', {
    params: payload,
    paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: 'repeat' }),
  });
};

export const fetchDevice = ({ dataCenterId, deviceId }) => {
  const endpoint = rdcManual[dataCenterId];
  return endpoint.get(`/descriptors/augmented/${deviceId}`)
    .then(({ data }) => data);
};

export const fetchAllAvailableDeviceIds = (dataCenterId) => {
  const endpoint = rdcManual[dataCenterId];
  return endpoint.get('/descriptors/availableDescriptors').then((response) => (
    {
      [dataCenterId]: response.data,
    }
  ));
};

export const fetchSessionAvailable = () => (
  rdcApp.get('/deviceRestrictions/parallelSessions')
);

export const uploadApp = (app, onUploadProgress, cancelToken = () => null) => {
  const appFormData = new FormData();
  const config = {
    onUploadProgress,
    cancelToken: new axios.CancelToken(cancelToken),
  };

  appFormData.append('app', app);

  return rdcApp.post(
    '/apps/upload',
    appFormData,
    config,
  );
};

export { TestObjectClient };
